import { Link } from "react-router-dom";
import type { HelpArticle } from "../lib/types";

interface BreadcrumbsProps {
  items: HelpArticle[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  if (items.length <= 1) return null;

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {items.map((item, idx) => (
          <li key={item.slug} className="breadcrumb-item">
            {idx < items.length - 1 ? (
              <>
                <Link to={item.slug}>{item.title}</Link>
                <span className="breadcrumb-sep">/</span>
              </>
            ) : (
              <span className="breadcrumb-current">{item.title}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
